import { Button } from "antd";
import React from "react";
import { AdAutoPromotionStatus, AdStatus } from "../../../../../models";
import { getIconUrl } from "../../../../../services/asset";
import styles from "../adCard.scss"

export const PromotedButton = ({ ad, adActions, shouldShowSearchPagePosition }) => {

  return (

    <Button
      disabled={ad.status !== AdStatus.active}
      className={`${styles.button} ${ad.autoPromotionStatus === AdAutoPromotionStatus.enabled ? styles.autoPromotionButton : styles.promotedButton}`}
      onClick={ad.status !== AdStatus.active || ad.hasFreePromotion ? null :
        ad.autoPromotionStatus === AdAutoPromotionStatus.enabled ? adActions.onAutoPromotionDisable :
          ad.autoPromotionStatus === AdAutoPromotionStatus.disabled ? adActions.onAutoPromottionEnable :
            null
      }
    >

      <div>
        {ad.autoPromotionStatus !== AdAutoPromotionStatus.enabled && <img
          src={ad.status !== AdStatus.active ? getIconUrl("promote-small-gray.svg") :
            getIconUrl("promote-small-yellow.svg")
          }
        />}
        {ad.autoPromotionStatus === AdAutoPromotionStatus.enabled && (
          ad.promotionRemainingHours < 24 ?
            [1, 21].includes(ad.promotionRemainingHours) ?
              "Ponovno isticanje za {0} sat.".replace("{0}", String(ad.promotionRemainingHours))
              : [2, 3, 4, 22, 23, 24].includes(ad.promotionRemainingHours) ?
                "Ponovno isticanje za {0} sata.".replace("{0}", String(ad.promotionRemainingHours))
                : "Ponovno isticanje za {0} sati.".replace("{0}", String(ad.promotionRemainingHours))
            : ad.promotionRemainingDays == 0 ? "Ponovno isticanje za {0} sati.".replace("{0}", String(ad.promotionRemainingHours)) :
              ad.promotionRemainingDays == 1 ||
                (
                  ad.promotionRemainingDays % 10 == 1 &&
                  ad.promotionRemainingDays % 100 != 11
                ) ?
                "Ponovno isticanje za {0} dan.".replace("{0}", String(ad.promotionRemainingDays))
                : "Ponovno isticanje za {0} dana.".replace("{0}", String(ad.promotionRemainingDays))
        )}
        {ad.autoPromotionStatus === AdAutoPromotionStatus.disabled && (
          ad.promotionRemainingHours < 24 ?
            [1, 21].includes(ad.promotionRemainingHours) ?
              "Istaknuto još {0} sat.".replace("{0}", String(ad.promotionRemainingHours))
              : [2, 3, 4, 22, 23, 24].includes(ad.promotionRemainingHours) ?
                "Istaknuto još {0} sata.".replace("{0}", String(ad.promotionRemainingHours))
                : "Istaknuto još {0} sati.".replace("{0}", String(ad.promotionRemainingHours))
            : ad.promotionRemainingDays == 0 ? "Istaknuto još {0} sati.".replace("{0}", String(ad.promotionRemainingHours)) :
              ad.promotionRemainingDays == 1 ||
                (
                  ad.promotionRemainingDays % 10 == 1 &&
                  ad.promotionRemainingDays % 100 != 11
                ) ?
                "Istaknuto još {0} dan.".replace("{0}", String(ad.promotionRemainingDays))
                : "Istaknuto još {0} dana.".replace("{0}", String(ad.promotionRemainingDays))
        )}

      </div>



      {shouldShowSearchPagePosition && (
        <span className={styles.subText}>
          {`Trenutno na ${ad.searchPagePosition}. stranici kategorije`}
        </span>
      )}
    </Button>
  )
}


// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/AdCard/AdCardActions/PromotedButton.tsx